import { render } from "./amazonec2.vue?vue&type=template&id=690de11e"
import script from "./amazonec2.vue?vue&type=script&lang=js"
export * from "./amazonec2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__